import React, { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useStartDepots } from './apiHooks';
import CustomSelect from '../../components/customFields/customSelect';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCar, faTrash } from '@fortawesome/free-solid-svg-icons';
import AdminRoutePlanV2RouteSetupPickupSlotVehicle from './adminRoutePlanV2RouteSetupPickupSlotVehicle';
import AdminRoutePlanV2RouteSetupPickupSlotDisplay from './adminRoutePlanV2RouteSetupPickupSlotDisplay';

const AdminRoutePlanV2RouteSetupPickupSlot = ({ pickupSlot, onPickupSlotRemove, onChange }) => {
  const [showPickupSlotForm, setShowPickupSlotForm] = useState(!pickupSlot.id);

  const { startDepots } = useStartDepots();

  const onFieldChange = (fieldName, newValue) => {
    const newPickupSlot = { ...pickupSlot };
    newPickupSlot[fieldName] = newValue;
    onChange(newPickupSlot);
  };

  const onVehicleAdd = () => {
    const newPickupSlot = { ...pickupSlot };
    newPickupSlot.vehicles.push({
      vehicleId: `Vehicle ${pickupSlot.vehicles.length + 1}`,
      count: 1,
      capacity: 1,
      maxTravelTimeInMinutes: null,
      routingProfileName: null,
    });
    onChange(newPickupSlot);
  };

  const onVehicleChange = (index, newVehicle) => {
    const newPickupSlot = { ...pickupSlot };
    newPickupSlot.vehicles[index] = newVehicle;
    onChange(newPickupSlot);
  };

  const onVehicleRemove = (vehicleIndex) => {
    const newPickupSlot = { ...pickupSlot };
    newPickupSlot.vehicles.splice(vehicleIndex, 1);
    onChange(newPickupSlot);
  };

  const { formatMessage } = useIntl();

  const startDepotOptions = startDepots
    ? startDepots.map((depot) => ({
        value: depot.id,
        label: `#${depot.id} - ${depot.name}`,
      }))
    : [];

  return (
    <div className="form-block m-darker m-b-3">
      <div className="row">
        <div className="col-12">
          <div className="form-group m-b-2">
            <div className="checkbox">
              <label>
                <input
                  type="checkbox"
                  checked={showPickupSlotForm}
                  onChange={() => setShowPickupSlotForm(!showPickupSlotForm)}
                />{' '}
                <FormattedMessage id={'admin.route.plan.setups.setup.field.pickup.slot.show.form'} />
              </label>
            </div>
          </div>
        </div>
        {showPickupSlotForm ? (
          <>
            <div className="col-12 col-sm-6">
              <div className="form-group">
                <label className="control-label">
                  <FormattedMessage id={'admin.route.plan.setups.setup.field.pickup.slot.name'} />
                </label>
                <input
                  className="form-control"
                  placeholder=""
                  type="text"
                  value={pickupSlot.name}
                  onChange={(e) => onFieldChange('name', e.target.value)}
                />
              </div>
            </div>
            <div className="col-12 col-sm-6">
              <label>
                <FormattedMessage id={'admin.route.plan.setups.setup.field.pickup.slot.start.depot'} />
              </label>
              <div className="form-group">
                <div className="m-b-2">
                  <CustomSelect
                    onChange={(depot) => onFieldChange('startDepotId', depot)}
                    schema={{
                      title: '',
                      options: startDepotOptions,
                      showClearOption: true,
                    }}
                    formData={pickupSlot.startDepotId}
                  />
                </div>
              </div>
            </div>
            <div className="col-6 col-sm-3">
              <div className="form-group">
                <label className="control-label">
                  <FormattedMessage id={'admin.route.plan.setups.setup.field.pickup.slot.pickup.from.hour'} />
                </label>
                <input
                  className="form-control"
                  placeholder=""
                  type="text"
                  value={pickupSlot.pickupFromHour}
                  onChange={(e) => onFieldChange('pickupFromHour', e.target.value)}
                />
              </div>
            </div>
            <div className="col-6 col-sm-3">
              <div className="form-group">
                <label className="control-label">
                  <FormattedMessage id={'admin.route.plan.setups.setup.field.pickup.slot.pickup.from.minutes'} />
                </label>
                <input
                  className="form-control"
                  placeholder=""
                  type="text"
                  value={pickupSlot.pickupFromMinutes}
                  onChange={(e) => onFieldChange('pickupFromMinutes', e.target.value)}
                />
              </div>
            </div>
            <div className="col-6 col-sm-3">
              <div className="form-group">
                <label className="control-label">
                  <FormattedMessage id={'admin.route.plan.setups.setup.field.pickup.slot.pickup.to.hour'} />
                </label>
                <input
                  className="form-control"
                  placeholder=""
                  type="text"
                  value={pickupSlot.pickupToHour}
                  onChange={(e) => onFieldChange('pickupToHour', e.target.value)}
                />
              </div>
            </div>
            <div className="col-6 col-sm-3">
              <div className="form-group">
                <label className="control-label">
                  <FormattedMessage id={'admin.route.plan.setups.setup.field.pickup.slot.pickup.to.minutes'} />
                </label>
                <input
                  className="form-control"
                  placeholder=""
                  type="text"
                  value={pickupSlot.pickupToMinutes}
                  onChange={(e) => onFieldChange('pickupToMinutes', e.target.value)}
                />
              </div>
            </div>

            <div className="col-12">
              <hr />
              <h4>
                <FormattedMessage id={'admin.route.plan.setups.setup.field.pickup.slot.vehicles'} />
              </h4>
            </div>

            <div className="col-12">
              {pickupSlot.vehicles.map((vehicle, index) => {
                return (
                  <AdminRoutePlanV2RouteSetupPickupSlotVehicle
                    key={index}
                    vehicle={vehicle}
                    onChange={(newVehicle) => onVehicleChange(index, newVehicle)}
                    onRemove={() => onVehicleRemove(index)}
                  />
                );
              })}
              <div>
                <button onClick={onVehicleAdd} className="btn btn-normal-link btn-small">
                  <FontAwesomeIcon icon={faCar} /> <FormattedMessage id={'admin.route.plan.setups.add.new.vehicle'} />
                </button>
              </div>
              <div className="text-right">
                <button
                  className="btn btn-normal-link btn-small"
                  onClick={() => {
                    if (
                      window.confirm(
                        formatMessage({ id: 'admin.route.plan.setups.setup.field.pickup.slot.remove.confirm' })
                      )
                    ) {
                      onPickupSlotRemove();
                    }
                  }}
                >
                  <FontAwesomeIcon icon={faTrash} />{' '}
                  <FormattedMessage id={'admin.route.plan.setups.setup.field.pickup.slot.remove'} />
                </button>
              </div>
            </div>
          </>
        ) : (
          <div className="col-12">
            <AdminRoutePlanV2RouteSetupPickupSlotDisplay pickupSlot={pickupSlot} />
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminRoutePlanV2RouteSetupPickupSlot;
